import { spinnerVariant, type SpinnerVariantProps } from "./spinner.variants";

export type UseSpinnerProps = SpinnerVariantProps & {
  className?: string;
  style?: Record<string, string | number>;
  label?: string;
};

export const useSpinner = (props: UseSpinnerProps) => {
  const { className = "", ...componentProps } = props;

  const styles = spinnerVariant();

  return {
    className,
    styles,
    componentProps,
  };
};
